/** Resident list "How to mark rent paid" walkthrough — copy authored to match Angular. */
export const RESIDENT_PAYMENT_INSTRUCTION_STEPS = [
  {
    body: (
      <>
        Select all of your Resident(s) who have paid this month&apos;s rent to mark them as{' '}
        <strong>&apos;Paid in Full&apos;</strong>. You can either click &apos;Select All&apos; and
        uncheck the ones that have not paid yet, or just click the check box for them individually.
      </>
    ),
  },
  {
    body: (
      <>
        Next select your Resident(s), who have not paid this month to mark them as{' '}
        <strong>&apos;Not Paid in Full&apos;</strong> and start the Reimbursement process.
      </>
    ),
  },
  {
    body: (
      <>
        If a Resident pays &apos;in full&apos; after you marked them as{' '}
        <strong>&apos;Not Paid in Full&apos;</strong> and you have not started the Reimbursement
        process, then you can remark them as <strong>&apos;Paid in Full&apos;</strong> for that
        month. However, if you have started the Reimbursement process, and the Resident has
        &apos;caught up&apos; for all previous rent, then you should Cancel the Reimbursement first,
        then mark them as <strong>&apos;Paid in Full&apos;</strong>.
      </>
    ),
  },
] as const

